import { render, staticRenderFns } from "./PSUPlaceOfDeliveryUtility.vue?vue&type=template&id=223ded8c&scoped=true&"
import script from "./PSUPlaceOfDeliveryUtility.vue?vue&type=script&lang=js&"
export * from "./PSUPlaceOfDeliveryUtility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223ded8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
